export const sanitizeApiKey = (apiKey: string): string => {
  if (!apiKey) return '';
  return apiKey.replace(/^['"](.*)['"]$/, '$1').trim();
};

export const validateApiKey = (apiKey: string): boolean => {
  if (!apiKey) return false;
  return apiKey.length > 10 && /^[a-zA-Z0-9_-]+$/.test(apiKey);
};
